export const FEATURE_DESCRIPTION = {
	PREBID_SETTINGS: 'Add bidders and set their parameters to participate in auctions',
	SITE_CONFIG: {
		GENERAL_SETTINGS:
			'Manage default site-level settings including Site ID, domain, owner details, MCM ID, video player, and associated GAM IDs',
		SPLIT_CONFIG_SETTINGS:
			'This allows running experiments by dividing traffic across sections. You can either compare multiple sections against each other or assign 100% traffic to a single section.',
		EXPERIMENTS_CONTEXT:
			'Here you can create an experiment section from the control section and compare them using an A/B split test',
		TP_VAST_CONFIG: 'Third-party VAST tags configuration',
		CHANGE_LOGS:
			'View all changes made in the Framerate Dashboard, including the action status, date, and the user who performed the changes.',
		AGRESSIVE_VP_MUTE_COVERAGE_CONFIG:
			'When Aggressive VP Mute is enabled, we randomly decide after how many ad requests we start sending vpMute = 0 in the ad request. This does not change the player’s mute state; if disabled, vpMute follows the current player status.'
	},
	VIDEO_CONTENT: {
		VIDEO: 'Video content to run in the player',
		CTA_CUSTOM_FEATURES: 'Call-to-action button over the player',
		PAGE_LEVEL_CONTENT_VIDEOS: {
			SUMMARY: 'Show page-specific videos across your site.',
			INFO: 'Turns page level content videos on or off for this site. To turn them off for one section, use Features Data > Page Level Content Override. RSS Video Generation needs this turned on.'
		},
		RSS_VIDEO_GENERATION: {
			SUMMARY: 'Create videos automatically from an RSS feed or from an article URL.',
			INFO: 'Creates videos from new articles in an RSS feed, or from one article URL. The feed is checked on a set schedule, and no more than the daily limit of articles is fetched per day. Enable Page Level Content Videos for this site first.'
		},
		RSS_INFO_MESSAGES: {
			DAILY_LIMIT: 'The maximum number of articles to fetch from this feed per day.',
			LANGUAGE: 'The language used to generate video content from articles in this feed.',
			POLLING_SCHEDULE: 'How often the RSS feed is checked for new articles, in minutes.',
			VIDEO_TEMPLATE: 'The video template used to generate videos from this feed.',
			FEED_ACTIVE: 'Enable this to start polling for new articles, make sure the status is green and active once you enable it.'
		}

	},
	FORMAT_DATA: {
		PLAYER_SIZES:
			'In this section, you can adjust the player size for all devices in both floating and in-content modes',
		PLAYER_UI:
			'Here you can choose where the player will appear on all devices when it’s inside the content or floating on the screen.',
		CUSTOM_FLOAT:
			'Custom floating player setting - to be used to setup some custom requirement from the publisher',
		CUSTOM_STYLE_TAG: 'Here we can add custom styles to adjust the player and fix CSS conflicts',
		OVERLAY_CLICK_BLOCKER:
			'Add a click-blocker layer over the player to avoid accidental clicks on the player or on the video ads'
	},
	NETWORK_DATA: {
		DFP_ADUNITS: 'GAM ad units',
		AD_UNITS_CONFIG:
			'Order of sending the ad requests to the ad units ( Sequential would send ad requests in the order as setup in DFP units | Random would send ad requests randomly between all the available DFP ad units )',
		GAM_UPR_CONFIG:
			'When enabled, you can define custom floor/UPR values for different platforms (like desktop or mobile), operating systems (like Android or iOS), and countries to better control pricing.',
		FP_ENGINE:
			'When enabled, this feature automatically adjusts floor prices up or down based on whether ads are filling or not.',
		HB_FLOORS_CONFIG: 'To apply separate floors for the HB partners',
		HB_ONLY: 'Run only Header-Bidding via GAM - no Adx',
		CUSTOM_VAST_TAG:
			'To send ad requests only to the VAST tags added below - Ad requests would not be send to any other demand source apart from the VAST tags added in this section',
		HB_ADX_SPLIT_CONFIG:
			'Decide the split between ad requests - to send Adx only ad requests in between/with standard auction(HB+Adx)',
		HB_BIDDER_TIMEOUT: 'Time until which the auction will wait for a response from the HB bidders',
		VAST_FE_CONFIG: 'Floor Engine setting',
		COMPANION_ADS: 'Setup companions ads along with the player : banner ads just below the player',
		OVERLAY_ADS:
			'Overlay ads are small banner ads shown at the bottom of the video. If no video ad is available, we display an overlay ad instead',
		HYBRID_ADS:
			'When enabled, Hybrid Outstream Ads automatically switch between banner and video ads in a floating player, so you always show an ad and maximize earnings without disturbing user experience',
		MAX_AD_DURATION:
			'This parameter may be used to restrict creatives to a duration required in ad tag for single ads',
		GAM_UPR_FLOOR_AUTOMATION:
			'When Floor Engine is enabled, floor prices are dynamically optimized.'
	},
	REQUEST_STRUCTURE_DATA: {
		BATCHED_AD_REQUESTS: `Ad requests are sent in controlled groups, with delays applied between batches and sections. Each batch consists of a defined number of requests (Request Batch Size), followed by a time gap before the next batch begins (Batch Delay Time). A section is made up of multiple batches (Request Section Size), and once a section is complete, an additional delay is applied before the next section starts (Section Delay Time).`,
		REQUEST_BLOCKING: 'Here, you can configure request blocking for specific countries',
		MAX_UNFILL_BEFORE_BACKFILL:
			'To add backfill ad units after a certain number of ad requests are sent to the standard ad units',
		INITIAL_REQUEST_DELAY:
			'When enabled, you can set a time delay (in milliseconds) before the first ad request is sent.',
		CUSTOM_ERROR_REFRESH:
			'To increase the delay between the ad requests when the error rate is high',
		SUBSEQUENT_AD_REQUESTS:
			'Send ad requests in advance to play another ad instantly after the current ad is over',
		TERMINATE_AD_AFTER_DURATION_MULTIPLIER:
			"Multiplier is the percentage of the ad's total duration at which it should be terminated.",
		SUBSEQUENT_AD_REQUEST_DELAY_CONFIG:
			'Control the delay time (ms) between the queued ad and the current ad playing.',
		OPTIMIZED_TPV_REQUESTS:
			'Configure optimized TPV requests with max back pocket ads capacity for improved ad delivery'
	},
	EXPERIMENTAL_FEATURES_DATA: {
		BTF_REQUEST_CONFIG:
			'Send ad request(s) on the page load - before the player comes in view : Serves impression when the player comes in view',
		AMP_ACTIVE_TAB: 'Send ad requests on AMP player in active tab state',
		LOG_ADDITIONAL_DATA: 'Add logging for additional data',
		BG_REQUEST_CONFIG:
			'The bgRequestConfig feature enables background ad requests only if it is turned on in the configuration and the user’s country is included in the whitelisted countries list',
		VIDEO_CREATIVE_PROFILE: 'Video creative profile rules for serving ads',
		CUSTOM_PLACEMENT_PARAM:
			'To define the inventory type of player on the page - Instream - 1/ Accompanying content - 2 /Outstream - 4',
		ADVANCED_OPTIMIZATION:
			'Optimisation feature to detect interaction of the user on the page - player',
		AGGRESSIVE_VPMUTE:
			'Aggressive vpMute means the player always tries to play with sound from the beginning, even if it looks muted. It keeps checking every second if sound autoplay is allowed, without waiting for you to click or interact',
		AUDIO_CONTEXT_PLAYER_VOL:
			'When enabled, it lets you set both the ad volume and the player volume for the video',
		AUTOPLAY_FOR_IOS: 'Start ad requests on iOS devices before the player comes in view'
	},
	FEATURES_DATA: {
		VIDEO_AUTOPLAY:
			'When enabled for a specific device, videos will automatically play without requiring any user action.',
		FLOATING_UNIT_CONFIG:
			'To control when to float the player on the site when the user scrolls on the page(s)',
		UAM_CONFIG: 'Amazon UAM configuration settings',
		DISABLE_AP_LOGO: 'When enabled, the AdPushup logo will be shown on the player.',
		AUTOSKIP_AD:
			'Automatically skips ads after a set time, with options to enable/disable, set skip timing, define minimum ad length, and reset on interaction',
		THUMBNAIL_URL:
			'URL of the image that would display on the player before the video content starts playing',
		CUSTOM_LABEL_CONFIG: 'Label/Brand Name over the player for white-labelling the video solution',
		PENCIL_FLOAT_CONFIG:
			'Enables a responsive floating video player optimized for mobile devices. The player spans the full width of the screen, with the video displayed clearly on one side and the title on the other for quick identification.',
		CUSTOM_TARGETING: 'GAM targeting to seprate out the data for this particular section',
		VIEW_PLAYBACK: 'Track and manage video playback behaviour for analytics or optimizations',
		VAST_DAISY_CHAINING:
			'The vastDaisyChaining feature lets you control how ad requests are shared between AdPushup GAM and third-party GAM tags. You can set how many requests go to each, choose whether to start with third-party tags, and decide if extra requests should be sent before switching',
		BANNER_REPLACEMENT:
			'When this feature is enabled, if a video ad is not available, we show a banner ad in place of the video player at the start.',
		VIDEO_TO_BANNER_SWITCH_IN_CONTENT:
			'This replaces the in-content video player with a banner when the player starts floating.',
		BACKFILL_VAST:
			'Additional VAST tags to which we can send ad requests, after sending the ad requests to the Adpushup demand sources',
		FLOATING_ONLY_CONFIG:
			'When enabled, the player will always remain in floating mode instead of switching back to in-content',
		AD_ONLY_FLOATING: 'Enable this to make the player float only when an ad is playing',
		STOP_AFTER_CROSS_CLICK:
			'When enabled, ad requests will stop after the user clicks the close button',
		FALLBACK_TAG_CONFIG:
			'Passback tag - to be used when we want to switch to some other player/demand source',
		HB_WITHOUT_GAM:
			'Serve direct HB creatives from Prebid server in case unfilled from Adx (inflates the HB bids and sends as floor for Adx)',
		AD_REQUESTS_RHEOSTAT:
			'Adds an additional delay to ad requests based on threshold and delay percentage values to reduce the number of ad requests.',
		HB_DECOUPLING:
			'When enabled, this feature allows you to decouple the ad requests for Header Bidding (HB) and Ad Exchange (Adx). This means that ad requests for HB and Adx can be sent independently, allowing for more flexible ad serving strategies.',
		PAGE_LEVEL_CONTENT_VIDEOS:
			'By default, page level content videos follow the site-level configuration. Use this option to disable the feature for the selected section. Leave it unchecked to follow the site-level setting.'
	}
};
